import React from "react";
import { useTranslation } from "react-i18next";
import { placeholderLabel } from "../../utility/placeholderLabel";
import GarageChargerImage from "resources/images/GarageChargerImage.png";
import { useNavigate } from "react-router-dom";
import {
  handleNameChange,
  handlePriceChange,
  handleSelectionChange,
  TextBoxSelection,
  TextBoxSelectionData,
} from "components/basic/textBoxSelection";
import { useEditMode } from "../../utility";
import WizardPageLayout from "../../components/WizardPageLayout";
import WizardSection from "../../components/WizardSection";
import WizardButton from "../../components/WizardButton";
import logger from "utils/logger";

const FORM_WIDTH = 440;

interface ChargerConfigurationProps {
  data: ChargerConfigData;
  setData: React.Dispatch<React.SetStateAction<ChargerConfigData>>;
}

export interface ChargerConfigData {
  evseType: TextBoxSelectionData[];
}

const ChargerConfiguration: React.FC<ChargerConfigurationProps> = ({
  data,
  setData,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation("services");
  const { isEditMode, handleSave, handleCancel } = useEditMode(data, setData);

  logger.log("ChargerConfiguration Render", { data, isEditMode });

  return (
    <WizardPageLayout
      title={t("wizard.charger.title")}
      image={{
        src: GarageChargerImage,
        alt: t("wizard.image_alt"),
        side: "left",
      }}
      contentMaxWidth={FORM_WIDTH}
      actions={
        <>
          <WizardButton
            color="primary"
            onClick={() => {
              if (isEditMode) {
                navigate(`?currentPage=${handleCancel()}`);
              } else {
                navigate("");
              }
            }}
          >
            {t(isEditMode ? "wizard.cancel" : "wizard.back")}
          </WizardButton>

          <WizardButton
            color="warning"
            onClick={() =>
              isEditMode
                ? navigate(`?currentPage=${handleSave()}`)
                : navigate("?currentPage=installationConfig")
            }
          >
            {t(isEditMode ? "wizard.save" : "wizard.next")}
          </WizardButton>
        </>
      }
    >
      <WizardSection title={t("wizard.charger.evse")}>
        {data.evseType.map((element) => (
          <TextBoxSelection
            key={element.id}
            textBoxSelectionType={element.type}
            label={element.optionName}
            checked={element.isChecked}
            onSelectionChange={(checked) =>
              handleSelectionChange<TextBoxSelectionData>(
                setData,
                checked,
                "evseType",
                element.id,
                element.duplicates,
              )
            }
            onPriceChange={(e) =>
              handlePriceChange(setData, element.id, e, "evseType")
            }
            price={element.price}
            name={element.enteredName}
            onNameChange={(e) =>
              handleNameChange(setData, element.id, e, "evseType")
            }
            placeHolder={placeholderLabel(t, element.placeholder)}
          />
        ))}
      </WizardSection>
    </WizardPageLayout>
  );
};

export default ChargerConfiguration;
